import DocumentDetailDateValue from "./DocumentDetailDateValue";

const DocumentDetailFieldValue = {
  Date: DocumentDetailDateValue,
};

export default DocumentDetailFieldValue;
